import React from 'react'
import { FormattedMessage } from 'react-intl'


//компонент с информацией что оплачивать можно только картами банков РФ
const NationalCards = ({classname}) => {
    return (
        <div className={`national-items ${classname ? classname : ''}`}>
            <div className='national-item'><FormattedMessage id='national_card.only' /></div>
            <div className='national-item'><FormattedMessage id='national_card.change' /></div>
        </div>
    )
}

export default NationalCards


// WEBPACK FOOTER //
// ./src/components/NationalCards.jsx